import axios from "axios";

export const getLaboralAreas = callback => {
  var promise = axios({
    method: "get",
    url: "/api/laboral_areas"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
